document.addEventListener('DOMContentLoaded', function () {
  const productContainer = document.querySelector('#ProductsList');
  if (!productContainer) return;

  let firstLoadDone = false;

  function sortProducts() {
    const productItems = Array.from(productContainer.querySelectorAll('.f-column.card'));

    const inStockItems = productItems.filter(item =>
      !item.querySelector('.f-badge--soldout')
    );
    const outOfStockItems = productItems.filter(item =>
      item.querySelector('.f-badge--soldout')
    );

    const allSortedItems = [...inStockItems, ...outOfStockItems];

    // Réorganise sans retirer du DOM
    allSortedItems.forEach(item => {
      productContainer.insertBefore(item, null); // déplace à la fin sans supprimer
    });

    // Affiche la liste après le premier tri
    if (!firstLoadDone) {
      productContainer.classList.add('loaded');
      firstLoadDone = true;
    }
  }

  function loadAllProducts() {
    const loadMoreButton = document.querySelector('button[is="load-more-button"]');

    if (loadMoreButton && loadMoreButton.offsetParent !== null) {
      const observer = new MutationObserver((mutations, obs) => {
        obs.disconnect();
        sortProducts(); // Tri après chaque chargement partiel
        loadAllProducts(); // Continue à charger les pages suivantes
      });

      observer.observe(productContainer, { childList: true, subtree: true });

      loadMoreButton.click();
    } else {
      sortProducts(); // Tri final au cas où
    }
  }

  loadAllProducts();
});
